import React, { Component }               from "react";
import { Link, withRouter }               from "react-router-dom";
import { Nav, NavItem, Navbar }           from "react-bootstrap";
import Routes                             from "./Routes";
import RouteNavItem                       from "./components/RouteNavItem";
import FB                       from "./components/chat/FacebookChat";
import { authUser, signOutUser }          from "./libs/awsLib";
import StopWatch                          from "./components/StopWatch";
import styled, {withTheme, ThemeProvider} from 'styled-components';
import { library }                        from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon }                from '@fortawesome/react-fontawesome'
import { fas }                            from '@fortawesome/free-solid-svg-icons'
import { fab, faYoutube }                 from '@fortawesome/free-brands-svg-icons'
import Amplify, { Auth }                  from 'aws-amplify';
import theme                              from 'styled-theming';
import { WhiteLabel }                     from "./utils/WhiteLabelProps";
import { invokeGetUnreadMessages,
         invokeGetZoom }                   from "./utils/AwsInvoke";
//import CustomerChat                       from "./components/chat/CustomerChat";

import "./css/App.css";

library.add(fas, fab, faYoutube)
var white_label = WhiteLabel();
var company_id  = white_label.company_id;

const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
const asp_company_id            = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";

const StyledNavbar = styled(Navbar)`
    background-color: ${props => props.theme.primary};
	border: 0px solid #ccc;
`;

const MainColor = "#539d57"; //{this.props.mainColor} //styled.h1`color: ${props => props.mainColor};`;

const StyledImageLogo = {
    position:"absolute",
    top:"18px",
    left:"70px",
    maxHeight:"25px",
    zIndex: "1001"
}

const StyledMessageIcon = {
    position:"absolute",
    top:"10px",
    left:"20px",
    paddingLeft: "10px",
    paddingTop: "9px",
    width:"42px",
    height:"42px",
    borderRadius: "20px",
    backgroundColor: "#eee",
    border:"1px solid #ccc",
    cursor: "pointer",
    zIndex: "1000"
}

const AlertBadge1 = {
    position:"absolute",
    top:"0px",
    left:"67px",
    float:"right",
    display:"inline",
    width:"16px",
    height:"16px",
    borderRadius: "8px",
    backgroundColor: "red",
    zIndex: "1010"
}

const AlertBadge2 = {
    position:"absolute",
    top:"0px",
    left:"78px",
    float:"right",
    display:"inline",
    width:"14px",
    height:"14px",
    borderRadius: "7px",
    backgroundColor: "red",
    zIndex: "1010"
}

class App extends Component {
    constructor(props) {
        super(props);

        var globalUserId        = localStorage.getItem('globalUserId');
        var globalUserEmail     = localStorage.getItem('globalUserEmail');
        var globalUserCompanyId = localStorage.getItem('globalUserCompanyId');

        var globalUserTrainerId    = localStorage.getItem('globalUserTrainerId');
        var globalUserTrainerName  = localStorage.getItem('globalUserTrainerName');
        var globalUserTrainerPhone = localStorage.getItem('globalUserTrainerPhone');

        this.state = {
            isAuthenticated: false,
            isAuthenticating: true,
            displayStopwatch: false,
            showNewMessage: "none",
            globalUserId: globalUserId,
            globalUserEmail: globalUserEmail,
            globalUserCompanyId: globalUserCompanyId,

            globalUserTrainerId: globalUserTrainerId,
            globalUserTrainerName: globalUserTrainerName,
            globalUserTrainerPhone: globalUserTrainerPhone,

            hideMenu: false,
            unReadMessages: false,
            showMainAlertBadge: "none",
            unReadMessageIdsArray: [],

            // Default Help Welcome Tour is turned off //
            showHelpTour: false
        };

        // Read comments below on why not to use the resize browser function //
        //this.updateBrowserDimensions = this.updateBrowserDimensions.bind(this);
    }

    async componentDidMount() {

        try {
            var globalUserId           = this.state.globalUserId;
            var globalUserEmail        = this.state.globalUserEmail;
            var globalUserCompanyId    = this.state.globalUserCompanyId;

            var globalUserTrainerId    = this.state.globalUserTrainerId;
            var globalUserTrainerName  = this.state.globalUserTrainerName;
            var globalUserTrainerPhone = this.state.globalUserTrainerPhone;

            var url      = window.location.pathname;
            var url_path = url.substring(url.lastIndexOf('/')+1);

            if (url_path === "login" || url_path === "reset" || url_path === "signup")
                    this.setState({hideMenu: true})

            // Ensure that the logout handle isn't called on the Reset and Signup page, otherwise it will redirect to Login //
            if(url_path != "reset" && url_path != "signup") {
                // If app loads and the User Id is not tracked, have user login again //
                // if(globalUserId === "null" || globalUserId === null)
                    // temp remove 5/29: for some reason logs out users 5x in one workout session //
                    // this.handleLogout(null);
            } else {
                //this.handleLogout(null); // don't use, it recycles logout
                // catches if user logged out and allows user to go to Reset or Signup page
                this.setState({ isAuthenticating: false });
            }

            if (await authUser()) {
                // Read comments below on why not to use the resize browser function //
                // this.updateBrowserDimensions();
                // Resize function used for split screen view and to layer message details over message summaries
                // window.addEventListener("resize", this.updateBrowserDimensions);


                this.userHasAuthenticated(true);

                // 9.26. hold on to this; it works fine but...
                // the search fields and athlete set metrics get cleared during the timer increment;
                // i think it's because there's a new state change
                // INITIATE RETRIEVAL OF NEW MESSAGES //
                // this.checkForUnreadMessages();
            }
        }
        catch(e) {
            alert(e);
        }

        this.setState({ isAuthenticating: false });
    }

    componentWillUnmount() {
        // Read comments below on why not to use the resize browser function //
        //window.removeEventListener("resize", this.updateBrowserDimensions);
    }

    startCheckNewMessagesTimer(action) {
        console.log("----- BEGIN Timer -----");

        /* 9/26: Temp remove until messages is fixed again
        var timer_secs = 15; // seconds for refresh rate
        var timer;
        var that  = this;
        //clearInterval(timer);
        if(action === "reset") {
            //console.log("ACTION RESET only once");
            clearInterval(timer);
            startTimer();
        }

        function startTimer () {
            timer = setInterval(function(){
                timer_secs--;
                that.setState({
                    pageTimerSecs: timer_secs,
                    refreshPageTimer: false //reset timer
                })
                console.log("this.timer: " + timer_secs);
                if(timer_secs <= 0) {
                    clearInterval(timer);
                    //that.getMessagesList("Retrieving Message ... ")
                    that.checkForUnreadMessages();
                }
            }, 1000);
        }*/
    }

    checkForUnreadMessages = async () => {
        var globalUserId = this.state.globalUserId;
        console.log("**********  ATHLETE SIDE TIMER  **********");
        this.setState({
            unReadMessages: false,
            unReadMessageIdsArray: [] // reset
        })

        var results = await invokeGetUnreadMessages(globalUserId);

        if(results.length > 0) {
            console.log("*****  THERE's a NEW MESSAGE!!!  *****  ");
            var msg_array = [];
            for(var key in results) {
                var message_id = results[key].message_id;

                msg_array.push(message_id);
            }
            this.setState({
                unReadMessages: true,
                unReadMessageIdsArray: msg_array,
                showNewMessage: "inline"
            })

            // Begin Once: check for new messages every 15 secs
            this.startCheckNewMessagesTimer("reset");
        } else {
            console.log("There's NO New Messages....");
            this.setState({
                unReadMessages: false,
                unReadMessageIdsArray: [] // reset
            })
            // Begin Once: check for new messages every 15 secs
            this.startCheckNewMessagesTimer("reset");
        }/* */
    }

    userHasAuthenticated = authenticated => {
        this.setState({ isAuthenticated: authenticated });
    }

    handleLogout = event => {
        signOutUser();

        this.userHasAuthenticated(false);
        localStorage.setItem('globalUserId', null); // reset global user id
        localStorage.setItem('globalUserEmail', null); // reset global user id
        localStorage.setItem('globalUserCompanyId', null); // reset global user company id
        // Trainer information is used when sending a 'New' Message' //'
        localStorage.setItem('globalUserTrainerId', null);
        localStorage.setItem('globalUserTrainerName', null);
        localStorage.setItem('globalUserTrainerPhone', null);

        this.setState({
            hideMenu: true
        })
        this.props.history.push("/login");
    }

    setGlobalUserProps = (user_id, user_email, company_id, trainer_id, trainer_name, trainer_phone, athlete_id) => {

        localStorage.setItem('globalUserId', user_id);
        localStorage.setItem('globalUserEmail', user_email);
        localStorage.setItem('globalUserCompanyId', company_id); // company user belongs to
        // Trainer information is used when sending a 'New' Message' //'
        localStorage.setItem('globalUserTrainerId', trainer_id);
        localStorage.setItem('globalUserTrainerName', trainer_name);
        localStorage.setItem('globalUserTrainerPhone', trainer_phone);

        this.setState({
            hideMenu: false,
            globalUserId: user_id,
            globalUserEmail: user_email,
            globalUserCompanyId: company_id,
            globalUserTrainerId: trainer_id,
            globalUserTrainerName: trainer_name,
            globalUserTrainerPhone: trainer_phone
        })
    }

    showStopwatch = (display) => {
        this.setState({
            displayStopwatch: display
        })
    }

    showMessagesScreen = () => {
        console.log("RESET unread messages to 0;");
        this.setState({
            showNewMessage: "none",
            unReadMessageIdsArray: [] // reset unread messages array
        }, function() {
            this.props.history.push("/message/listAll");
        });
    }

    hideNewMessageIcon = () => {
        this.setState({
            showNewMessage: "none",
            unReadMessageIdsArray: [] // reset unread messages array
        })
    }

    openMenu = () => {
        var showMainAlertBadge = "none";
        if(this.state.showMainAlertBadge === "none") showMainAlertBadge = "inline"

        this.setState({
            showMainAlertBadge: showMainAlertBadge
        })
    }

    showProgressScreen = () => {
        this.props.history.push("/progress/tracker");
    }

    openHelpTour = () => {
        //console.log("helpTour.");
        this.setState({
            showHelpTour: true
        })
    }

    closeFBChat () {
        window.closeFBChat();

        //FB => FB.CustomerChat.show(true);
        //var shouldShowDialog;
        //FB => FB.CustomerChat.show(shouldShowDialog: true);
        //console.log("closeFBChat!!!");
        /*this.setState({
            openFBChat: false
        })*/
    }

    showHomeScreen = () => {
        this.props.history.push("/");
    }

    showHelpScreen = () => {
        window.open("https://acceleratesp.typeform.com/to/QzjtDi", '_blank');
    }

    showProblemScreen = () => {
        window.open("https://acceleratesp.typeform.com/to/ayPpsM", '_blank');
    }

    setCoverImage = (img_src) => {
        // Was going to pass as childProps but if a user refreshes the page (ie workoutDetails),
        // it will lose the image name and will be undefined; // thus, must use localStorage
        localStorage.setItem('coverImage', img_src);
    }

    getZoomSig = async (event) => {
        var meeting_role = 2; // Meeting Attendee
        var sig;

        var results = await invokeGetZoom(meeting_role);

        if(results.status) {

                var zoom_url   = "https://zoom.trainingslate.com"; //"http://127.0.0.1:9999"; //
                var zoom_sig   = results.signature;
                var meeting_id = results.meeting_id;
                var mp         = results.meeting_password;
                var api_key    = results.api_key;
                var logo;

                if(company_id == posture_health_company_id)
                    logo = "posture";
                else if(company_id == asp_company_id)
                    logo = "asp";
                // Don't Erase.
                console.log("1. zoom_sig: " +  zoom_sig);
                console.log("1. meeting_id: " +  meeting_id);
                console.log("1. meetingPassword: " +  mp);

                window.open(zoom_url+"/index.html?type=2&mid="+meeting_id+"&mp="+mp+"&key="+api_key+"&sig="+zoom_sig+"&logo="+logo, "_blank");
        }
    }

    openZoomWindow = async () => {
        console.log("1. wait");
        await this.getZoomSig();
    }

    render() {
        var athlete_id  = white_label.athlete_id;
        var url         = white_label.url;
        var message_component = "";

        if(athlete_id == undefined) athlete_id = this.state.globalUserId;

        // Show Messages Link //
        // Temp removed 4/26/21
        /* if(url === "asp-athlete.trainingslate.com" || url === "ts-athlete.trainingslate.com")
                message_component = <span onClick={this.closeFBChat}>Message</span>*/

        const childProps = {
            isAuthenticated:        this.state.isAuthenticated,
            userHasAuthenticated:   this.userHasAuthenticated,
            setGlobalUserProps:     this.setGlobalUserProps,
            globalUserId:           athlete_id,
            globalUserCompanyId:    this.state.globalUserCompanyId,
            globalUserEmail:        this.state.globalUserEmail,
            globalUserTrainerId:    this.state.globalUserTrainerId,
            globalUserTrainerName:  this.state.globalUserTrainerName,
            globalUserTrainerPhone: this.state.globalUserTrainerPhone,
            unReadMessageIdsArray:  this.state.unReadMessageIdsArray,
            checkForUnreadMessages: this.checkForUnreadMessages,
            hideNewMessageIcon:     this.hideNewMessageIcon,
            setCoverImage:          this.setCoverImage,
            coverImage:             this.state.coverImage,
            showHelpTour:           this.state.showHelpTour
        };

        var renderHome               = <div></div>;
        var show_main_alert_badge    = "none";
        var show_submain_alert_badge = "none";
        var hide_menu = <Navbar.Toggle className="narbar-expand-xl"/>

        if(this.state.hideMenu)
            hide_menu = null;

        /* temp removed 4/12: if(this.state.unReadMessages) {
            show_main_alert_badge = this.state.showMainAlertBadge; // this is determined based on browser width
            show_submain_alert_badge = "inline";
        }*/

        var dynamic_navbar = [ <RouteNavItem key={110}
                                          style={{backgroundColor:"white !important"}}>
                                          <span className="routeNavItem">{ message_component }</span>
                                </RouteNavItem>,
                                <RouteNavItem key={101}
                                              href="/"
                                              style={{backgroundColor:"#fff", borderBottomLeftRadius: "0px"}}>
                                              <span className="routeNavItem">Home</span>
                                </RouteNavItem>,
                                <RouteNavItem key={100}
                                              style={{backgroundColor:"white !important"}}
                                              onClick={this.showProgressScreen}>
                                              <span className="routeNavItem">Progress Tracker</span>
                                </RouteNavItem>,
                                <RouteNavItem key={103}
                                              style={{backgroundColor:"#fff"}}
                                              onClick={this.showHelpScreen}>
                                              <span className="routeNavItem">Help</span>
                                </RouteNavItem>,
                                <RouteNavItem key={104}
                                              style={{backgroundColor:"#fff"}}
                                              onClick={this.showProblemScreen}>
                                              <span className="routeNavItem">Report Problem</span>
                                </RouteNavItem>,
                                <RouteNavItem key={105}
                                              style={{backgroundColor:"#fff", borderBottomRightRadius: "0px !important"}}
                                              onClick={this.handleLogout}>
                                              <span className="routeNavItem">Logout
                                                  <span style={{fontSize:12}}> (v4.26b)</span>
                                              </span>
                                </RouteNavItem> ]

        // BEGIN: If site url comes from PH //

        { /*}<RouteNavItem key={101}
                      href="/scheduler"
                      style={{backgroundColor:"#fff", borderBottomLeftRadius: "0px"}}>
                      <span className="routeNavItem">Scheduler</span>
        </RouteNavItem>,*/ }

        if(company_id === posture_health_company_id || company_id == asp_company_id)
                dynamic_navbar = [ <RouteNavItem key={110}
                                                 style={{backgroundColor:"white !important"}}>
                                                 <span className="routeNavItem">{ message_component }</span>
                                    </RouteNavItem>,
                                    <RouteNavItem key={101}
                                                  href="/"
                                                  style={{backgroundColor:"#fff", borderBottomLeftRadius: "0px"}}>
                                                  <span className="routeNavItem">Home</span>
                                    </RouteNavItem>,
                                    <RouteNavItem key={10111}
                                                  onClick={this.openZoomWindow}
                                                  style={{backgroundColor:"#fff", borderBottomLeftRadius: "0px"}}>
                                                  <span className="routeNavItem">Zoom</span>
                                    </RouteNavItem>,
                                    <RouteNavItem key={103}
                                                  style={{backgroundColor:"#fff"}}
                                                  onClick={this.showHelpScreen}>
                                                  <span className="routeNavItem">Help</span>
                                    </RouteNavItem>,
                                    <RouteNavItem key={104}
                                                  style={{backgroundColor:"#fff"}}
                                                  onClick={this.showProblemScreen}>
                                                  <span className="routeNavItem">Report Problem</span>
                                    </RouteNavItem>,
                                    <RouteNavItem key={105}
                                                  style={{backgroundColor:"#fff", borderBottomRightRadius: "0px !important"}}
                                                  onClick={this.handleLogout}
                                                  >
                                                  <span className="routeNavItem"> { /*Logout*/ }
                                                      <span style={{fontSize:12}}> (v4.26b)</span>
                                                  </span>
                                    </RouteNavItem>];
        // END: PH DYNAMIC NAVBAR //

        if(!this.state.isAuthenticating)
            renderHome = <div className="App containe">
                                { /*}<CustomerChat />*/ }
                                <div className="loginBox">
                                        <StyledNavbar fluid
                                                      collapseOnSelect
                                                      defaultExpanded = {false}
                                                      style    = {{ backgroundColor:"transparent", zIndex:1050}}
                                                      onClick  = {this.openMenu}
                                        >
                                                <span style={{display: show_main_alert_badge}}>
                                                    <span style={AlertBadge1} />
                                                </span>
                                                <Navbar.Header>
                                                    <Link to="/">
                                                        { /*}<img src={logo} style={StyledImageLogo} alt={logo}/>*/ }
                                                    </Link>
                                                    <Navbar.Brand>
                                                        { /*}< Link to="/">TS Test App</Link> */ }
                                                    </Navbar.Brand>
                                                    { hide_menu }

                                                </Navbar.Header>
                                                { /* }<RouteNavItem key={102}
                                                              style={{backgroundColor:"#fff"}}
                                                              onClick={this.showMessagesScreen}>
                                                        { /*}<span style={{display: show_submain_alert_badge}}>
                                                            <span style={AlertBadge2}/>
                                                        </span> / }
                                                    Messages
                                                </RouteNavItem>,*/ }
                                                {/*}<RouteNavItem key={101}
                                                              href="/"
                                                              style={{backgroundColor:"#fff", borderBottomLeftRadius: "0px"}}>
                                                  Home
                                                </RouteNavItem>,*/}
                                                <Navbar.Collapse>
                                                    <Nav pullRight style={{position:"relative", display: "inline-block", top: -4, height: "20 !important", zIndex: 100}}>
                                                        { /*}<NavItem onClick={this.handleLogout}>Logout</NavItem>*/ }
                                                      {this.state.isAuthenticated
                                                        ?  dynamic_navbar
                                                        : ""/* [
                                                            /*<RouteNavItem key={3} href="/signup">
                                                              Signup
                                                            </RouteNavItem>,
                                                            <RouteNavItem key={4} href="/login">
                                                              Login
                                                          </RouteNavItem>
                                                          ]*/ }
                                                    </Nav>
                                                </Navbar.Collapse>
                                      </StyledNavbar>
                                        <Navbar style= {{display:"inline-block !important", padding:"0px !important", height:"10px !important", color:"#fff !important", backgroundColor: "transparent", border: 0}}>
                                          <Nav pullRight>

                                              { /*}<NavItem onClick={this.handleLogout}>Logout</NavItem>*/ }
                                            {this.state.isAuthenticated
                                              ?  [
                                                  /*<RouteNavItem key={1} href="/">
                                                    Home
                                                  </RouteNavItem>,
                                                  <RouteNavItem onClick={this.showMessagesScreen}>
                                                    Messenger
                                                </RouteNavItem>,

                                                <NavItem key={2} onClick={this.handleLogout}>
                                                  Logout
                                                </NavItem>*/
                                                ]
                                              : [
                                                  /*<RouteNavItem key={3} href="/signup">
                                                    Signup
                                                  </RouteNavItem>,
                                                  <RouteNavItem key={4} href="/login">
                                                    Login
                                                  </RouteNavItem>/* */
                                                ]}
                                          </Nav>
                                        </Navbar>
                                        { /*}------  NEW MESSAGE  ------*/ }
                                        <span style={{display: this.state.showNewMessage, position:"absolute", top: 77, right: 30, cursor: "pointer",zIndex: 1000}}
                                              onClick={this.showMessagesScreen}>
                                              <span className="newMessageCircle" />
                                              <span className="newMessageLabel">new</span>
                                              <span className="glyphicon glyphicon-comment newMessageIcon" />

                                        </span>
                                </div>
                                { /*}<div style={StyledMessageIcon} onClick={this.showMessagesScreen}>
                                    <span className="glyphicon glyphicon-comment" style={{fontSize:"20px", color:"#deb00e"}} />
                                </div>
                                <div>
                                    <img src={logo} style={StyledImageLogo} alt={logo}/>
                                </div>*/ }
                                <span onClick={this.showHomeScreen}  style={{float:"left", position: "absolute", top:9,left: 10, cursor: "pointer", zIndex:2000}}>
                                    <img src={ this.props.logo } style={{display:"inline-block", maxWidth:240, maxHeight:40}}/>
                                </span>
                                <span className="headerLogo" ></span>
                                <div style={{zIndex:500}}>
                                    <Routes childProps={childProps} handleLogout={this.handleLogout} showStopwatch={this.showStopwatch} />
                                </div>
                                <StopWatch displayStopwatch = {this.state.displayStopwatch} />
                    </div>

        return (
            <div>
                { renderHome }
            </div>
        )
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js